import * as wasm from '../wasm.js';
export var wallet;
(function (wallet) {
    async function generateMnemonic(params) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.generateMnemonic(params ?? null);
    }
    wallet.generateMnemonic = generateMnemonic;
    async function validateMnemonic(mnemonic, languageCode) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.validateMnemonic(mnemonic, languageCode ?? null);
    }
    wallet.validateMnemonic = validateMnemonic;
    async function mnemonicToSeed(mnemonic, passphrase) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.mnemonicToSeed(mnemonic, passphrase ?? null);
    }
    wallet.mnemonicToSeed = mnemonicToSeed;
    async function deriveKeyFromSeedPhrase(params) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.deriveKeyFromSeedPhrase(params);
    }
    wallet.deriveKeyFromSeedPhrase = deriveKeyFromSeedPhrase;
    async function deriveKeyFromSeedWithPath(params) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.deriveKeyFromSeedWithPath(params);
    }
    wallet.deriveKeyFromSeedWithPath = deriveKeyFromSeedWithPath;
    async function deriveKeyFromSeedWithExtendedPath(params) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.deriveKeyFromSeedWithExtendedPath(params);
    }
    wallet.deriveKeyFromSeedWithExtendedPath = deriveKeyFromSeedWithExtendedPath;
    async function deriveDashpayContactKey(params) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.deriveDashpayContactKey(params);
    }
    wallet.deriveDashpayContactKey = deriveDashpayContactKey;
    async function derivationPathBip44Mainnet(account, change, index) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathBip44Mainnet(account, change, index);
    }
    wallet.derivationPathBip44Mainnet = derivationPathBip44Mainnet;
    async function derivationPathBip44Testnet(account, change, index) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathBip44Testnet(account, change, index);
    }
    wallet.derivationPathBip44Testnet = derivationPathBip44Testnet;
    async function derivationPathDip9Mainnet(featureType, account, index) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathDip9Mainnet(featureType, account, index);
    }
    wallet.derivationPathDip9Mainnet = derivationPathDip9Mainnet;
    async function derivationPathDip9Testnet(featureType, account, index) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathDip9Testnet(featureType, account, index);
    }
    wallet.derivationPathDip9Testnet = derivationPathDip9Testnet;
    async function derivationPathDip13Mainnet(account) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathDip13Mainnet(account);
    }
    wallet.derivationPathDip13Mainnet = derivationPathDip13Mainnet;
    async function derivationPathDip13Testnet(account) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.derivationPathDip13Testnet(account);
    }
    wallet.derivationPathDip13Testnet = derivationPathDip13Testnet;
    async function deriveChildPublicKey(xpub, index, hardened) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.deriveChildPublicKey(xpub, index, hardened);
    }
    wallet.deriveChildPublicKey = deriveChildPublicKey;
    async function xprvToXpub(xprv) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.xprvToXpub(xprv);
    }
    wallet.xprvToXpub = xprvToXpub;
    async function generateKeyPair(network) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.generateKeyPair(network);
    }
    wallet.generateKeyPair = generateKeyPair;
    async function generateKeyPairs(network, count) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.generateKeyPairs(network, count);
    }
    wallet.generateKeyPairs = generateKeyPairs;
    async function keyPairFromWif(privateKeyWif) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.keyPairFromWif(privateKeyWif);
    }
    wallet.keyPairFromWif = keyPairFromWif;
    async function keyPairFromHex(privateKeyHex, network) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.keyPairFromHex(privateKeyHex, network);
    }
    wallet.keyPairFromHex = keyPairFromHex;
    async function pubkeyToAddress(pubkeyHex, network) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.pubkeyToAddress(pubkeyHex, network);
    }
    wallet.pubkeyToAddress = pubkeyToAddress;
    async function validateAddress(address, network) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.validateAddress(address, network);
    }
    wallet.validateAddress = validateAddress;
    async function signMessage(message, privateKeyWif) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.signMessage(message, privateKeyWif);
    }
    wallet.signMessage = signMessage;
})(wallet || (wallet = {}));
